import {
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import React, { createContext, useEffect, useState } from "react";
import auth, {
  getSignleDocFromFirestore,
  firestore,
} from "../services/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import User from "../classes/User";

const USER_COLLECTION = "Users";

type MyContextValue = {
  currentUser: User;
  logInWithGoogle: () => Promise<void>;
  logOut: () => Promise<void>;
  updateCurrentUser: (newUser: User) => void;
  getCurrentUser: () => any;
};

const initialContextValue: MyContextValue = {
  currentUser: {
    id: "",
    uid: "",
    userName: "",
    userId: "",
    email: "",
    mobileNumber: "",
    profilePicUrl: "",
    userType: "",
    createdAt: 0,
    groups: [],
    pendingInvites: [],
  },
  updateCurrentUser: () => {},
  getCurrentUser: () => {},
  logInWithGoogle: () => new Promise((resolve, reject) => {}),
  logOut: () => new Promise((resolve, reject) => {}),
};

export const GlobalContext = createContext(initialContextValue);

type MyContextProviderProps = {
  children: React.ReactNode;
};

const localStorageUserKey = "F09LGsOeQ1QY5cVYc2tnI7dKJHK";

export const GlobalContextProvider: React.FC<MyContextProviderProps> = ({
  children,
}) => {
  const [currentUser, setCurrentUser] = useState<User>({
    id: "",
    uid: "",
    userName: "",
    userId: "",
    email: "",
    mobileNumber: "",
    profilePicUrl: "",
    userType: "",
    createdAt: 0,
    groups: [],
    pendingInvites: [],
  });

  const getCurrentUserFromFb = async (userId: string) => {
    const path = `${USER_COLLECTION}/${userId}`;
    const docSnap = await getSignleDocFromFirestore(path);
    if (docSnap.exists()) {
      try {
        const userData: User = docSnap.data() as User;
        updateCurrentUser(userData);
      } catch (err) {
        console.log("Error", err);
      }
    }
  };

  const updateCurrentUser = (newUser: User) => {
    setCurrentUser(newUser);
    localStorage.setItem(localStorageUserKey, JSON.stringify(newUser));
  };

  const getCurrentUser = (): User | null => {
    const localStorageValue = localStorage.getItem(localStorageUserKey);
    if (localStorageValue) {
      try {
        return JSON.parse(localStorageValue) as User;
      } catch (error) {
        console.log("error while converting localstorage data to User");
      }
    }
    return null;
  };

  const logInWithGoogleOld = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userRef = doc(firestore, USER_COLLECTION, user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        // New user → Save to Firestore
        const newUser: User = {
          id: user.uid,
          uid: user.uid,
          userName: user.displayName ?? "",
          userId: user.email ?? "",
          email: user.email ?? "",
          mobileNumber: "",
          profilePicUrl: user.photoURL ?? "",
          userType: "",
          createdAt: Date.now(),
          groups: [],
          pendingInvites: [],
        };
        await setDoc(userRef, newUser);
        updateCurrentUser(newUser);
      } else {
        // Existing user
        updateCurrentUser(userSnap.data() as User);
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      throw error;
    }
  };

  const logInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithRedirect(auth, provider);
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      throw error;
    }
  };

  const logOut = () => {
    localStorage.removeItem(localStorageUserKey);
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser?.uid) {
        getCurrentUserFromFb(authUser?.uid);
      }
    });

    return () => unsubscribe();
  }, []);

  const localStorageUserData = getCurrentUser();
  if (currentUser.id === "" && localStorageUserData !== null) {
    updateCurrentUser(localStorageUserData);
  }

  const values = {
    logInWithGoogle,
    logOut,
    currentUser,
    updateCurrentUser,
    getCurrentUser,
  };

  return (
    <GlobalContext.Provider value={values}>{children}</GlobalContext.Provider>
  );
};

/*import {
  UserCredential,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import React, { createContext, useEffect, useState } from "react";
import auth, { getSignleDocFromFirestore } from "../services/firebase";
import User from "../classes/User";

const USER_COLLECTION = "Users";
const HORSE_COLLECTION = "VtvHorseCollection";

type MyContextValue = {
  currentUser: User;
  logIn: (email: string, password: string) => Promise<UserCredential>;
  logOut: () => Promise<void>;
  updateCurrentUser: (newUser: User) => void;
  getCurrentUser: () => any;
};

const initialContextValue: MyContextValue = {
  currentUser: {
    id: "",
    uid: "",
    userName: "",
    userId: "",
    email: "",
    mobileNumber: "",
    profilePicUrl: "",
    userType: "",
    createdAt: 0,
  },
  updateCurrentUser: () => {},
  getCurrentUser: () => {},
  logIn: function (email: string, password: string): Promise<UserCredential> {
    return new Promise((resolve, reject) => {});
  },
  logOut: () => {
    return new Promise((resolve, reject) => {});
  },
};

export const GlobalContext = createContext(initialContextValue);

type MyContextProviderProps = {
  children: React.ReactNode;
};

const localStorageUserKey = "LGsOeQ1QY5cVYc2tnI7dKJhf";

export const GlobalContextProvider: React.FC<MyContextProviderProps> = ({
  children,
}) => {
  const [currentUser, setCurrentUser] = useState<User>({
    id: "",
    uid: "",
    userName: "",
    userId: "",
    email: "",
    mobileNumber: "",
    profilePicUrl: "",
    userType: "",
    createdAt: 0,
  });

  // console.log("GlobalContextProvider visited!");

  const getCurrentUserFromFb = (userId: string) => {
    const path = USER_COLLECTION + "/" + userId;
    getSignleDocFromFirestore(path).then((docSnap) => {
      if (docSnap.exists()) {
        try {
          const userData: User = docSnap?.data() as User;
          updateCurrentUser(userData);
        } catch (err) {
          console.log("Error", err);
        }
      }
    });
  };

  const updateCurrentUser = (newUser: User) => {
    setCurrentUser(newUser);
    console.log("Upadating user in storage ...");
    localStorage.setItem(localStorageUserKey, JSON.stringify(newUser));
  };

  const getCurrentUser = (): User | null => {
    const localStorageValue = localStorage.getItem(localStorageUserKey);
    if (localStorageValue) {
      try {
        return JSON.parse(localStorageValue) as User;
      } catch (error) {
        console.log("error while converting localstorage data to User");
      }
    }

    return null;
  };

  const logIn = (email: string, password: string) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logOut = () => {
    localStorage.removeItem(localStorageUserKey);
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser?.uid) {
        getCurrentUserFromFb(authUser?.uid);
      }
    });

    return () => unsubscribe();
  }, []);

  const localStorageUserData = getCurrentUser();
  if (currentUser && currentUser.id === "" && localStorageUserData !== null) {
    // console.log("Inside id condition");
    updateCurrentUser(localStorageUserData);
  }

  const values = {
    logIn,
    logOut,
    currentUser,
    updateCurrentUser,
    getCurrentUser,
  };

  return (
    <GlobalContext.Provider value={values}>{children}</GlobalContext.Provider>
  );
};
*/
